export default "__VITE_ASSET__CdfbQPy0__"